/*
    Объекты, появляющиеся при скролле
*/


let appObj;

class AppearObjects {
    constructor() {
        this.smController;
        this.selectors = '.appear';

        /*
            Таймаут нужен для того, чтобы объекты начинали
            всплывать уже после того, как поднимется прелоадер
        */
        setTimeout(() => {
            this.init();
        }, 1000);
    }



    init() {
        this.smController = new ScrollMagic.Controller({
            globalSceneOptions: {
                duration: '10000%',
                offset: App.H.width() > 767 ? 100 : 50
            }
        });

        App.H.find(this.selectors).each((i, el) => {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 'onEnter'
            })
            .addTo(this.smController)
            .on('enter', () => {
               $(el).addClass('_visible');
            });
        });


        /*
            Элементы, которые попадают в первый экран,
            должны появиться сразу после отработки прелоадера,
            даже если триггер скролла ещё не сработал
        */

        // Для первого объекта после верхушки подставляем атрибут вручную, если надо
        const $next = App.H.find('.first-screen').next();
        const $firstScreenAppearElements = App.H.find('.first-screen [data-appear-immediately]');
        
        if ($firstScreenAppearElements.length && $next.offset().top < App.W.height()) {
            $next.attr('data-appear-immediately', true);
        }


        App.H.find('[data-appear-immediately], [data-appear-immediately] .appear:eq(0)').addClass('_visible');

        // И костыль для карточек на странице категории
        if (App.W.width() < 768) {
            App.H.find('[data-barba-namespace="category"] .first-screen + .js-marquee + .preview-cards .appear').addClass('_visible');
        }
    }



    destroy() {
        try {
            this.smController = this.smController.destroy(true);
        } catch (error) {}
    }
}

App.W.on('barba:afterEnter', () => {
    // if (!App.mobile) {
        appObj = new AppearObjects();
    // }
});

App.W.on('barba:leave', () => {
    // if (!App.mobile) {
        try {
            appObj.destroy();
        } catch (error) { }
    // }
});



// WEBPACK FOOTER //
// ./_src/js/modules/AppearObjects.js